import React, { useState, useEffect } from "react";
import CtaLayout from "./CtaLayout";
import "../../styles/common.css";
import "../../styles/cta.css";

function CtaMarketing() {

  return (
    <>
      <CtaLayout title="Contact Us" lead="CONTACT">
        <div className='cta-box__text'>
          <h3>"I don't know how to attract customers..."<br />"I'm running ads, but the results are stagnating..."<br />If you have such challenges, please consult with LOGOT.</h3>
          <p>We provide comprehensive support from web marketing strategies to implementing measures that lead to increased inquiries and sales.<br />We leverage our expertise in the forefront of web marketing, including ad management, SEO strategies, and SNS utilization, to offer consulting-based support.<br />Please feel free to share your concerns with us.</p>
        </div>
      </CtaLayout>
    </>
  );
}

export default CtaMarketing;
